/**
 * ModeToggleSwitch Component Types
 */
export enum ChatMode {
  CAB = 'cab',
  DESIGN = 'design',
  BUILD = 'build'
}
export interface IModeToggleSwitchProps {
  /**
   * Current active mode
   */
  activeMode: ChatMode;
  
  /**
   * Callback when mode changes
   */
  onModeChange: (mode: ChatMode) => void;
  
  /**
   * Optional className for additional styling
   */
  className?: string;
  
  /**
   * Whether the toggle is disabled
   */
  disabled?: boolean;
}

